import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About Us', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Products', href: '#products' },
    { name: 'Contact', href: '#contact' },
  ];

  const services = [
    'Cloud Computing',
    'Software Solutions',
    'IT Infrastructure',
    'Cyber Security',
    'Network Solutions',
    'IT Consulting',
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <span className="text-3xl font-bold text-blue-400">Astrix</span>
              <span className="text-3xl font-bold text-orange-400">Infonet</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Complete IT solutions provider committed to delivering effective
              information technology services to businesses across industries.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="bg-gray-800 hover:bg-blue-600 p-3 rounded-full transition-colors duration-300">
                <FaLinkedin className="text-lg" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-blue-400 p-3 rounded-full transition-colors duration-300">
                <FaTwitter className="text-lg" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-blue-800 p-3 rounded-full transition-colors duration-300">
                <FaFacebook className="text-lg" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-pink-600 p-3 rounded-full transition-colors duration-300">
                <FaInstagram className="text-lg" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-300 flex items-center"
                  >
                    <span className="mr-2">→</span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a
                    href="#services"
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-300 flex items-center"
                  >
                    <span className="mr-2">→</span>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-orange-400 mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-400">
                  SF 28, Parsvnath Bibhab Plaza,<br />
                  Commercial Belt, Alfa 1,<br />
                  Greater Noida, U.P. 201308
                </span>
              </li>
              <li className="flex items-center">
                <FaPhone className="text-orange-400 mr-3 flex-shrink-0" />
                <a href="tel:+918272088330" className="text-gray-400 hover:text-orange-400 transition-colors">
                  +91 8272088330
                </a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-orange-400 mr-3 flex-shrink-0" />
                <a href="mailto:info@astrixinfonet.com" className="text-gray-400 hover:text-orange-400 transition-colors">
                  info@astrixinfonet.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Astrix Infonet. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-orange-400 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 text-sm transition-colors">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
